export default __webpack_public_path__ + "static/banner-one-shape8-0808ca384210289dab721c03e026bbaa.png";